export default __webpack_public_path__ + "static/media/5.1cc69005.png";